import { formatISODate, isDateSelectable, newDate, newDateYMD } from 'shared-utils/date-utils'
import type { IDateConstraints } from 'shared-types/calendar'

export type { IDateConstraints } from 'shared-types/calendar'

/**
 * Check if a date is excluded based on constraints
 */
export function isDateExcluded(date: Date, constraints: IDateConstraints): boolean {
  const excludedDatesStrings = (constraints.excludedates ?? []).map((d) =>
    typeof d === 'string' ? d : formatISODate(d),
  )

  return !isDateSelectable(
    date,
    constraints.earliest,
    constraints.latest,
    excludedDatesStrings,
    constraints.excludeweekdays ?? [],
  )
}

/**
 * Check if a day should be disabled for selection
 */
export function isDayDisabled(
  date: Date,
  isSelected: boolean,
  constraints: IDateConstraints,
  options: {
    multiple: boolean
    maxMultiple: number
    selectedCount: number
  },
): boolean {
  if (isDateExcluded(date, constraints)) return true

  if (
    !isSelected &&
    options.multiple &&
    options.maxMultiple > 0 &&
    options.selectedCount >= options.maxMultiple
  ) {
    return true
  }

  return false
}

/**
 * Check if navigation to previous month is allowed
 */
export function isPrevMonthAllowed(
  year: number,
  month: number,
  earliest: string | null,
): boolean {
  const prevMonth = newDateYMD(year, month, 0)
  if (earliest && newDate(earliest) > prevMonth) return false
  return true
}

/**
 * Check if navigation to next month is allowed
 */
export function isNextMonthAllowed(
  year: number,
  month: number,
  latest: string | null,
): boolean {
  const nextMonth = newDateYMD(
    month === 11 ? year + 1 : year,
    month === 11 ? 0 : month + 1,
    1,
  )
  if (latest && newDate(latest) < nextMonth) return false
  return true
}
